/* eslint-disable prettier/prettier */
// picture-search.component.ts
import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { catchError, debounceTime, take } from 'rxjs';
import { SearchResult } from 'src/app/search-result';
import { CarlineService } from 'src/app/services/carline.service';
import { CheckboxService } from 'src/app/services/checkbox-service.service';
import { ColumnWidthService } from 'src/app/services/columnwidth.service';
import { DataPaginatorService } from 'src/app/services/data-paginator.service';
import { ErrorHandlingService } from 'src/app/services/error-handling.service';
import { FileDisplayModeService } from 'src/app/services/filedisplaymode.service';
import { GridColumnsService } from 'src/app/services/grid-columns.service';
import { OrderTypeService } from 'src/app/services/ordertype.service';
import { SharedSearchService } from 'src/app/services/shared-search-service.service';
import { WorkstationService } from 'src/app/services/workstation.service';
import { SelectFileModule } from 'src/app/shared/select-file/select-file.module';
import { AlertComponent } from '../../alert-info/alert-info.component';
import { AlertInfoService } from '../../alert-info/service/alert-info.service';
import { AlertTypeEnum } from '../../alert-info/type/AlertType.enum';
import { ProductSearch } from '../../productsearch';
import { PictureSearchService } from '../../services/picture-search.service';
import { DateRangePickerComponent } from '../date-range-picker/date-range-picker.component';
import { CsvValuesDialogComponent } from './csv-values-dialog/csv-values-dialog.component';

export interface ProductSearchModel {
  file?: string[];
  ordertype?: string;
  carline?: string[];
  workstation?: string[];
  orderident?: string[];
  originalFilename?: string[];
  endDate?: string;
  startDate?: string;
  selection?: string;
  page?: number;
  pageSize?: number;
}

type CsvField = 'orderident' | 'file' | 'originalFilename';

@Component({
  selector: 'app-picture-search',
  templateUrl: './picture-search.component.html',
  styleUrls: ['./picture-search.component.css'],
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    DateRangePickerComponent,
    FormsModule,
    AlertComponent,
    CommonModule,
    MatIconModule,
    MatGridListModule,
    MatTooltipModule,
    MatSelectModule, // Import MatSelectModule
    MatOptionModule,
    MatRadioModule,
    CommonModule,
    FontAwesomeModule,
    SelectFileModule
  ],
})
export class PictureSearchComponent implements OnInit {
  searchParams: ProductSearchModel = {};
  pageSize: number = 25;
  gridCols!: number;
  model: ProductSearch;
  searchResults!: SearchResult;
  startDate?: string;
  endDate?: string;
  errorMessage!: string;
  @Output() searchResultsChanged = new EventEmitter<SearchResult>();
  @Output() searchClicked: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild(DateRangePickerComponent)
  dataRangeComponent!: DateRangePickerComponent;
  checkboxListComponent: any;
  isLoading = false;
  ordertypes: any[] = [];
  carline: any[] = [];
  workstations: any[] = [];

  fileDisplayMode: string = 'displayFileName';
  showFileDisplayModeError: boolean = false;

  readonly MAX_VALUES_PER_FIELD = 1000;

  csvValues: Record<CsvField, string[]> = {
    orderident: [],
    file: [],
    originalFilename: [],
  };

  private readonly csvFieldLabels: Record<CsvField, string> = {
    orderident: 'Orderident',
    file: 'Filename',
    originalFilename: 'OriginalFilename',
  };

  constructor(
    private pictureSearchService: PictureSearchService,
    private alerInfoService: AlertInfoService,
    private sharedSearchService: SharedSearchService,
    private checkboxService: CheckboxService,
    private columnWidthService: ColumnWidthService,
    public dataPaginatorService: DataPaginatorService,
    private carlineService: CarlineService,
    private workstationService: WorkstationService,
    private orderTypeService: OrderTypeService,
    private errorHandlingService: ErrorHandlingService,
    private girdColumnServive: GridColumnsService,
    private fileDisplayModeService: FileDisplayModeService,
    private dialog: MatDialog
  ) {
    this.model = new ProductSearch([], '', [], '', '', '', '', '', 'images');
    const mode = this.fileDisplayModeService.getFileDisplayMode();
    this.fileDisplayMode = mode && mode !== '' ? mode : 'displayFileName';
    this.fileDisplayModeService.setFileDisplayMode(this.fileDisplayMode);
  }

  handleDateRangeSelected(dateRange: Date[] | undefined): void {
    if (dateRange) {
      this.startDate = dateRange[0]?.toISOString();
      this.endDate = dateRange[1]?.toISOString();
    } else {
      // Handle the case when dateRange is undefined
      this.startDate = undefined;
      this.endDate = undefined;
    }
  }

  onFileDisplayModeChange(mode: string) {
    this.fileDisplayMode = mode;
    this.fileDisplayModeService.setFileDisplayMode(mode);
    this.showFileDisplayModeError = !mode;
  }

  selection: any[] = [
    { id: 'images', name: 'Images' },
    { id: 'html_files', name: 'HTML' },
    { id: 'text_files', name: 'Text' },
    { id: 'csv_files', name: 'CSV' },
    { id: 'default_files', name: 'other file type' },
    // Add more options as needed
  ];

  ngOnInit(): void {
    this.girdColumnServive.gridCols$.subscribe(cols=> {this.gridCols = cols;})
    this.fetchOrderTypes();
    this.fetchCarlineTypes();

     // Fetch order types when component initializes
  }


  showAlert(type: AlertTypeEnum, text: string) {
    this.alerInfoService.setAlert({
      type,
      text,
    });
  }

  onCarlineSelected(carlineIds: string[]) {
    // Upon selecting a carline, fetch corresponding workstations
    this.model.workstation = []; 

    if(!carlineIds || carlineIds.length === 0) {
      this.workstations = []; // Clear workstations if no carline is selected
      return;
    }
    this.fetchWorkstations(carlineIds);
  }


  submitted = false;

  onSubmit() {
    this.submitted = true;
  }

  showFormControls(form: any) {
    return form && form.controls.name && form.controls.name.value;
  }

  search(): void {
    this.pictureSearchService
      .search(this.searchParams)
      .pipe(debounceTime(3000), take(1))
      .subscribe(
        (result: any) => {
  
          // Check if result.body is present
          if (result.body && result.statusCode== 200) {


            this.searchResults = JSON.parse(result.body) as SearchResult;
            this.searchResultsChanged.emit(this.searchResults);
          } else if (result.body && result.statusCode != 200) {
            const bodyObject = JSON.parse(result.body);
            const errorMessage = bodyObject.message;
            this.errorHandlingService.handleError(result.statusCode, 'An internal server error occurred', errorMessage);
          }
          else  {
            // Handle the internal server error
            this.errorHandlingService.handleError( '500', 'Unexpected response:', result);
          }
        },
        (error) => {
          this.showAlert(
            AlertTypeEnum.warning,
            error.message || 'Error from Server',
          );
        },
      );
  }
  
  fetchWorkstations(carlineIds: string[]) {
    this.workstationService.fetchWorkstations(carlineIds).pipe(
      catchError((error) =>
        this.errorHandlingService.handleError('500','Error fetching workstations. You can still search with other parameters', error)
      )
    ).subscribe(
      (data) => {
        this.workstations = data.items;  // Assign fetched data to workstations array
      }
    );
  }

  fetchOrderTypes() {
    this.orderTypeService.fetchOrderTypes().pipe(
      catchError((error) =>
        this.errorHandlingService.handleError('500','Error fetching order types. You can still search with other parameters', error)
      )
    ).subscribe(
      (data) => {
        this.ordertypes = data.items;  // Assign fetched data to ordertypes array
      }
    );
  }
  
  fetchCarlineTypes() {
    this.carlineService.fetchCarlineTypes().pipe(
      catchError((error) =>
        this.errorHandlingService.handleError('500','Error fetching carline types. You can still search with other parameters',error)
      )
    ).subscribe(
      (data) => {
        this.carline = data.items;  // Assign fetched data to carline array
      }
    );
  }

  wait(milliseconds: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, milliseconds);
    });
  }
  

    onSearch(): void {
      // Validate file display mode
      if (!this.fileDisplayMode) {
        this.showFileDisplayModeError = true;
        this.showAlert(
          AlertTypeEnum.warning,
          'ERROR: Please select a File Display Mode!'
        );
        return;
      }
    this.checkboxService.clearSelectedRows();
    this.dataPaginatorService.resetToDefault();
    this.columnWidthService.setDefaultColumnWidth(50);
    this.checkboxListComponent;
    this.resetSearchParams();

    this.searchParams.carline = this.model.carline;
    this.searchParams.workstation = this.model.workstation;
    this.searchParams.ordertype = this.model.ordertype;
    this.searchParams.selection = this.model.selection || 'images';

    try {
      this.searchParams.orderident = this.getValuesForSearch('orderident');
    } catch (error) {
      this.showAlert(
        AlertTypeEnum.warning,
        'ERROR: You cannot use both manual input and CSV import for Orderident. Please clear one of them.'
      );
      return;
    }

    if ((this.searchParams.orderident?.length || 0) > this.MAX_VALUES_PER_FIELD) {
      this.showAlert(
        AlertTypeEnum.warning,
        `ERROR: Too many Orderident values selected. Maximum allowed is ${this.MAX_VALUES_PER_FIELD}. Please reduce the list.`
      );
      return;
    }

    try {
      this.searchParams.file = this.getValuesForSearch('file');
    } catch (error) {
      this.showAlert(
        AlertTypeEnum.warning,
        'ERROR: You cannot use both manual input and CSV import for File. Please clear one of them.'
      );
      return;
    }

    if ((this.searchParams.file?.length || 0) > this.MAX_VALUES_PER_FIELD) {
      this.showAlert(
        AlertTypeEnum.warning,
        `ERROR: Too many File values selected. Maximum allowed is ${this.MAX_VALUES_PER_FIELD}. Please reduce the list.`
      );
      return;
    }

    try {
      this.searchParams.originalFilename = this.getValuesForSearch('originalFilename');
    } catch (error) {
      this.showAlert(
        AlertTypeEnum.warning,
        'ERROR: You cannot use both manual input and CSV import for Original Filename. Please clear one of them.'
      );
      return;
    }

    if ((this.searchParams.originalFilename?.length || 0) > this.MAX_VALUES_PER_FIELD) {
      this.showAlert(
        AlertTypeEnum.warning,
        `ERROR: Too many Original Filename values selected. Maximum allowed is ${this.MAX_VALUES_PER_FIELD}. Please reduce the list.`
      );
      return;
    }

    if (this.endDate && this.startDate) {
      this.searchParams.endDate = this.endDate;
      this.searchParams.startDate = this.startDate;
    } else {
      this.searchParams.endDate = undefined;
      this.searchParams.startDate = undefined;
    }

  const relevantSearchValues = [
    this.searchParams.file,
    this.searchParams.carline,
    this.searchParams.workstation,
    this.searchParams.orderident,
    this.searchParams.originalFilename,
  ];

  const hasOtherCriteria = relevantSearchValues.some(value => this.hasValue(value));
  const hasDateRange = !!this.searchParams.startDate && !!this.searchParams.endDate;

    if (hasOtherCriteria || hasDateRange) {
      this.sharedSearchService.setProductSearchParams(this.searchParams);
      this.searchClicked.emit();
      this.search();
    } else {
      this.showAlert(
        AlertTypeEnum.warning,
        'ERROR: Please provide at minimum one parameter or a date range',
      );
    }
  }

  validateDates(startDate: string, endDate: string): boolean {
    // Check if either startDate or endDate is missing or undefined
    if (!startDate || !endDate) {
      return false;
    }

    // Additional validation logic if needed

    return true;
  }

  public clearFilter(): void {
    // Reset file display mode to default
    this.fileDisplayMode = 'displayFileName';
    this.fileDisplayModeService.setFileDisplayMode('displayFileName');
    this.showFileDisplayModeError = false;
    this.checkboxService.clearSelectedRows();
    this.columnWidthService.setDefaultColumnWidth(50);
    this.resetSearchParams();

    // Reset UI model/form fields
    this.model.workstation = [];
    this.model.file = '';
    this.model.carline = [];
    this.model.ordertype = '';
    this.model.orderident = '';
    this.model.originalFilename = '';
    this.model.startDate = '';
    this.model.endDate = '';
    this.model.selection = 'images';

    // Reset params sent to the backend
    this.searchParams.workstation = [];
    this.searchParams.file = [];
    this.searchParams.carline = [];
    this.searchParams.ordertype = '';
    this.searchParams.orderident = [];
    this.searchParams.originalFilename = [];
    this.searchParams.startDate = '';
    this.searchParams.endDate = '';
    this.searchParams.selection = 'images';

    this.csvValues = {
      orderident: [],
      file: [],
      originalFilename: [],
    };

    // Clear the date range
    this.startDate = '';
    this.endDate = '';

    if (this.dataRangeComponent) {
      this.dataRangeComponent.clearDateRange();
    }
  }
  

  resetSearchParams(): void {
    this.sharedSearchService.setProductSearchParamsPage(0);
    this.sharedSearchService.setProductSearchParamsPageSize(25);
  }

  private hasValue(value: unknown): boolean {
    if (Array.isArray(value)) {
      return value.length > 0;
    }

    return value !== null && value !== undefined && value !== '';
  }

  private splitCommaSeparatedValues(value?: string): string[] {
    if (!value) {
      return [];
    }

    return value
      .split(',')
      .map(item => item.trim())
      .filter(item => item !== '');
  }

  hasManualValue(field: CsvField): boolean {
    const value = this.model[field];
    return typeof value === 'string' && value.trim() !== '';
  }

  hasCsvValues(field: CsvField): boolean {
    return this.csvValues[field].length > 0;
  }

  getCsvTooltipText(field: CsvField): string {
    const fieldLabel = this.csvFieldLabels[field];

    if (this.hasManualValue(field)) {
      return `CSV import is disabled because ${fieldLabel} values were entered manually. Clear the input to import a CSV file.`;
    }

    return `Import a CSV file containing one or more ${fieldLabel} values separated by commas or new lines.`;
  }

  handleCSVContent(content: string | ArrayBuffer, field: CsvField): void {
    const fieldLabel = this.csvFieldLabels[field];

    if (this.hasManualValue(field)) {
      this.showAlert(
        AlertTypeEnum.warning,
        `ERROR: You cannot import a CSV file while ${fieldLabel} values are entered manually. Please clear the input first.`
      );
      return;
    }

    const csvContent = typeof content === 'string'
      ? content
      : new TextDecoder().decode(content);

    const parsedValues = this.parseCsvValues(csvContent);
    const uniqueValues = Array.from(new Set(parsedValues));

    this.csvValues[field] = uniqueValues;

    if (uniqueValues.length > this.MAX_VALUES_PER_FIELD) {
      this.showAlert(
        AlertTypeEnum.warning,
        `ERROR: Too many ${fieldLabel} values were imported. Maximum allowed is ${this.MAX_VALUES_PER_FIELD}. Please reduce the list.`
      );
    }
  }

  private parseCsvValues(content: string): string[] {
    return content
      .split(/[,\n\r]+/)
      .map(value => value.trim())
      .filter(value => value !== '');
  }

  private getValuesForSearch(field: CsvField): string[] {
    if (this.hasManualValue(field) && this.hasCsvValues(field)) {
      throw new Error(`Manual values and CSV values cannot both be used for ${field}.`);
    }

    if (this.hasCsvValues(field)) {
      return this.csvValues[field];
    }

    return this.splitCommaSeparatedValues(this.model[field]);
  }

  openCsvValuesDialog(columnName: string, values: string[]): void {
    this.dialog.open(CsvValuesDialogComponent, {
      width: '700px',
      maxWidth: '90vw',
      maxHeight: '80vh',
      data: {
        columnName,
        values,
        maxValues: this.MAX_VALUES_PER_FIELD,
      },
    });
  }

  clearCsvValues(field: CsvField): void {
    this.csvValues[field] = [];
    this.model[field] = '';
    this.searchParams[field] = [];
  }

}
